import script from "./UserKycFinalize.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserKycFinalize.vue?vue&type=script&setup=true&lang=ts"

import "./UserKycFinalize.vue?vue&type=style&index=0&id=707cdcce&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707cdcce"]])

export default __exports__